import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface ILogoutResult extends IResult {
  redirectUrl: string;
}

export class LogoutRequest extends Request<{}, ILogoutResult> {
  constructor() {
    super('logout', {});
  }
}
